import { render, staticRenderFns } from "./WithdrawPage.vue?vue&type=template&id=af09d656&scoped=true"
import script from "./WithdrawPage.vue?vue&type=script&lang=js"
export * from "./WithdrawPage.vue?vue&type=script&lang=js"
import style0 from "./WithdrawPage.vue?vue&type=style&index=0&id=af09d656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af09d656",
  null
  
)

export default component.exports